import React from 'react';
import { useIntl } from 'react-intl';
import {connect} from 'react-redux';
import { getMessageValue } from '../i18n/messageUtil';
import RuleEvaluator from '@ignitesales/rule-evaluator/index';
import PropTypes from 'prop-types';

const ruleEval = new RuleEvaluator();

const MessageWithRuleEvaluation = (props) => {
  const {
    id,
    children,
    showIfNoRulePresent = true,
    answers
  } = props;

  ruleEval.setAnswers(answers);
  const intl = useIntl();
  const ruleMessage = getMessageValue(intl.locale, `${id}.rule`);
  const ruleIsValid = ruleMessage ? ruleEval.isTrue(ruleMessage) : false;

  return ruleIsValid || (!ruleMessage && showIfNoRulePresent) ? <>{ children }</> : null;
};

MessageWithRuleEvaluation.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.any,
  showIfNoRulePresent: PropTypes.bool,
  answers: PropTypes.any.isRequired
};

export default connect( state => {
  const answerObj = state.answers || {};
  const answers = [];
  /* eslint-disable-next-line no-unused-vars */
  for(let [key,value] of Object.entries(answerObj)) {
    answers.push(value);
  }

  return {
    answers
  };
})(MessageWithRuleEvaluation);
